module.exports = __webpack_public_path__ + "img/promo-banner3.f1b146e2.png";